<script setup lang="ts">
  import { uiAvatarSrc } from '@/functions/user-photo'

  defineProps<{
    name: string,
    src: string | null,
  }>()
</script>

<template>
  <app-img
    :title="name"
    :src="src ?? uiAvatarSrc(name ?? '')"
    type="person"
    class="photo-container" />
</template>

<style lang="postcss" scoped>
  .photo-container {
    @apply size-8 overflow-hidden rounded-full bg-white;
  }
</style>
